import React, { useState } from 'react';
import styled from '@emotion/native';
import Dropdown from '@/shared/components/Dropdown';
import useInstantStylingStore from '@/stores/useInstantStylingStore';
import { useShallow } from 'zustand/react/shallow';
import {
  AgeRange,
  Gender,
  StylingPreferenceRequest,
} from '@/shared/types/generated';
import {
  FieldLabel,
  SubheaderText,
  Title,
} from '@/components/instantStyling/styledComponents';
import { GENDER_OPTIONS } from '@/shared/constants/onboarding';
import { AGE_OPTIONS, STYLE_OPTIONS } from '@/shared/constants/instantCall';
import { getDropdownOptionLabel } from '@/shared/utils';
import StaticInput from '@/shared/components/StaticInput';
import { mintGreenAlt } from '@/shared/styles/colors';

const ClientInstantCallMorePreferences = () => {
  const { requestForm, setRequestForm } = useInstantStylingStore(
    useShallow((state) => ({
      requestForm: state.requestForm,
      setRequestForm: state.setRequestForm,
    })),
  );

  const [isGenderMenuVisible, setIsGenderMenuVisible] = useState(false);
  const [isAgeRangeMenuVisible, setIsAgeRangeMenuVisible] = useState(false);
  const [isStyleMenuVisible, setIsStyleMenuVisible] = useState(false);

  return (
    <Container>
      <Title>{`Fine-Tune\nYour Request`}</Title>
      <SubheaderText>Help your stylist personalize the session.</SubheaderText>
      <FieldLabel>Any gender preference for your stylist?</FieldLabel>
      <Dropdown
        eyebrowText="GENDER"
        eyebrowTextStyle={{ fontSize: 9 }}
        options={GENDER_OPTIONS}
        selectedOption={getDropdownOptionLabel(
          requestForm.gender,
          GENDER_OPTIONS,
        )}
        onSelect={(option) =>
          setRequestForm({ gender: option.value.toString() as Gender })
        }
        isVisible={isGenderMenuVisible}
        setIsVisible={setIsGenderMenuVisible}
      />

      <FieldLabel>Do you have an age preference?</FieldLabel>
      <Dropdown
        eyebrowText="AGE"
        eyebrowTextStyle={{ fontSize: 9 }}
        options={AGE_OPTIONS}
        selectedOption={getDropdownOptionLabel(requestForm.age, AGE_OPTIONS)}
        onSelect={(option) =>
          setRequestForm({
            age: option.value.toString() as AgeRange,
          })
        }
        isVisible={isAgeRangeMenuVisible}
        setIsVisible={setIsAgeRangeMenuVisible}
      />

      <FieldLabel>How would you define your personal style?</FieldLabel>
      <Dropdown
        eyebrowText="STYLE"
        eyebrowTextStyle={{ fontSize: 9 }}
        options={STYLE_OPTIONS}
        selectedOption={getDropdownOptionLabel(
          requestForm.style,
          STYLE_OPTIONS,
        )}
        onSelect={(option) =>
          setRequestForm({
            style: option.value.toString() as StylingPreferenceRequest,
          })
        }
        isVisible={isStyleMenuVisible}
        setIsVisible={setIsStyleMenuVisible}
      />

      <FieldLabel>
        Anything else your stylist should know? (optional)
      </FieldLabel>
      <StaticInput
        placeholderText="Enter additional information"
        value={requestForm.details}
        onChange={(e) => setRequestForm({ details: e.nativeEvent.text })}
        labelText="DETAILS"
        multiline
        customStyles={{
          height: 148,
          marginBottom: 0,
          borderWidth: 0,
        }}
        outlineStyle={{ borderColor: mintGreenAlt, borderRadius: 10 }}
      />
    </Container>
  );
};

export default ClientInstantCallMorePreferences;

const Container = styled.View({
  width: '100%',
  paddingHorizontal: 30,
  paddingBottom: 86,
});
